import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { TagsApi } from '../../api/tags/tags-api';
import { TagsPickerComponent } from './components/TagsPicker/tags-picker.component';
import { CommonFormsModule } from '../Forms/forms.module';
import { TagsService } from './services/tags.service';
import { ManageTagsDialogComponent } from './components/ManageTagsDialog/manage-tags-dialog.component';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { TagGroupsApi } from '../../api/tags/tag-groups.api';
import { TagGroupsService } from './services/tag-groups.service';
import { LayoutModule } from '../Layout/layout.module';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { CommonBasicModule } from '../Basic/basic.module';
import { TakeOverModule } from '../TakeOver/take-over.module';

export const tagsModuleImports = [
    LocalizationModule,
    CommonModule,
    FormsModule,
    CoreDialogsModule,
    CommonFormsModule,
    AutoCompleteModule,
    MessageModule,
    TooltipModule,
    MiscModule,
    LayoutModule,
    CommonBasicModule,
    TakeOverModule
];

export const tagsModuleDeclarations = [
    TagsPickerComponent,
    ManageTagsDialogComponent,
];

@NgModule({
    imports: tagsModuleImports,
    declarations: tagsModuleDeclarations,
    exports: [
        TagsPickerComponent,
        ManageTagsDialogComponent,
    ],
    providers: [
        TagsApi,
        TagGroupsApi,
        TagsService,
        TagGroupsService
    ]
})
export class TagsModule { }
